var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout calculations" },
    [
      _c("m-table-settings", {
        attrs: {
          columns: _vm.tableData.columns,
          "disabled-columns": _vm.tableData.disabledColumns,
          "default-disabled-columns": _vm.tableData.defaultDisabledColumns,
          "with-categories": "",
        },
        on: { submit: _vm.submitTableSettings },
        model: {
          value: _vm.tableData.settingsModal,
          callback: function ($$v) {
            _vm.$set(_vm.tableData, "settingsModal", $$v)
          },
          expression: "tableData.settingsModal",
        },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [_vm._v("Расчеты")]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _vm.canEdit
            ? _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("c-button", {
                    staticClass: "calculations__actions__new-calc-desktop",
                    attrs: {
                      label: "Новый расчет",
                      icon: {
                        icon: "plus",
                        color: "white",
                      },
                      color: "blue",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/calculation/production")
                      },
                    },
                  }),
                  _c("c-button", {
                    staticClass: "calculations__actions__new-calc-mobile",
                    attrs: {
                      responsive: "",
                      label: "Новый расчет",
                      icon: {
                        icon: "plus",
                        color: "white",
                      },
                      color: "blue",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/calculation/production")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "calculations__filters" },
        [
          _c("m-manage-filters", {
            attrs: {
              modal: _vm.manageFiltersModal,
              "store-module": "calculations",
            },
            on: {
              close: function ($event) {
                _vm.manageFiltersModal = null
              },
              applyFilters: _vm.applyFilters,
            },
          }),
          _c(
            "b-row",
            {
              staticClass: "calculations__filters-row",
              attrs: {
                "cols-md": "12",
                "cols-lg": "12",
                "cols-xs": "2",
                "align-v": "end",
              },
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "calculations__filters-col mb-4",
                  attrs: { md: "8", xl: "5", lg: "4", xs: "2" },
                },
                [
                  _c("c-input-2", {
                    staticClass:
                      "documents-report-filters__item documents-report-filters__filial",
                    attrs: {
                      type: "select",
                      label: "Филиал",
                      "checkbox-value": _vm.filters.branchesReverse,
                      checkbox: true,
                      "checkbox-type": "icon",
                      "checkbox-tooltip": {
                        disabledText:
                          "Фильтр по всем значениям в справочнике, кроме выбранных",
                        activeText:
                          "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                        notActiveText:
                          "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                      },
                      multiple: true,
                      searchable: true,
                      placeholder: "Все",
                      items: _vm.branches2,
                    },
                    on: {
                      checkboxChange: function ($event) {
                        _vm.filters.branchesReverse = $event
                      },
                    },
                    model: {
                      value: _vm.filters.branches,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "branches", $$v)
                      },
                      expression: "filters.branches",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "calculations__filters-col mb-4",
                  attrs: { lg: "3", md: "4", xs: "2" },
                },
                [
                  _c("c-input", {
                    ref: "period",
                    attrs: {
                      label: "Период",
                      placeholder: "00.00.0000 - 00.00.0000",
                      clearable: true,
                      type: "period",
                      icon: "calendar",
                      "icon-right": true,
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "calculations__filters-col mb-4",
                  attrs: { xl: "2", lg: "3", md: "4", xs: "2" },
                },
                [
                  _c("c-select", {
                    attrs: { label: "Смена", items: _vm.shifts },
                    model: {
                      value: _vm.filters.shift,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "shift", $$v)
                      },
                      expression: "filters.shift",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "calculations__filters-col",
                  attrs: {
                    col: "",
                    "offset-lg": "9",
                    "offset-md": "0",
                    lg: "3",
                    md: "5",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculations__filters-actions mb-4 mt-2" },
                    [
                      _c("c-button", {
                        staticClass:
                          "calculations__filters-actions-item calculations__filters-actions-item-apply",
                        attrs: {
                          label: "Применить",
                          size: "large",
                          color: "blue",
                        },
                        on: { click: _vm.submitFilters },
                      }),
                      _c("c-button", {
                        staticClass:
                          "calculations__filters-actions-item calculations__filters-actions-item-reset",
                        attrs: { label: "Сбросить", size: "large" },
                        on: { click: _vm.resetFilters },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "calculations__content" }, [
        _c(
          "div",
          {
            staticClass: "calculations__charts-wrapper",
            class: { "calculations__charts-wrapper_active": _vm.chartsActive },
          },
          [
            _c("div", {
              staticClass: "layout__hr calculations__charts-wrapper-hr-top",
            }),
            _vm.showCharts
              ? _c("s-charts", { staticClass: "calculations-charts" })
              : _vm._e(),
            _c("div", {
              staticClass: "layout__hr calculations__charts-wrapper-hr-bottom",
            }),
          ],
          1
        ),
        _c("div", { staticClass: "calculations__settings" }, [
          !_vm.isLoadingTable
            ? _c("div", { staticClass: "calculations__summary" }, [
                _c("div", { staticClass: "calculations__summary-item" }, [
                  _vm._v(" Начислено/выплачено производству: "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.totalSumProduction.toLocaleString()) + " ฿"
                    ),
                  ]),
                  _vm._v(" / "),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.totalPaidProduction.toLocaleString()) +
                        " ฿ "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "calculations__summary-item" }, [
                  _vm._v(" Н/в доставке: "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.totalSumDriver.toLocaleString()) + " ฿"),
                  ]),
                  _vm._v("/"),
                  _c("span", [
                    _vm._v(_vm._s(_vm.totalPaidDriver.toLocaleString()) + " ฿"),
                  ]),
                ]),
              ])
            : _vm._e(),
          !_vm.isLoadingTable
            ? _c("div", { staticClass: "calculations__actions" }, [
                _c(
                  "div",
                  { staticClass: "calculations__actions-item" },
                  [
                    _c("c-button-2", {
                      attrs: {
                        icon: "chart",
                        active: !_vm.chartsActive,
                        responsive: true,
                        label: _vm.chartsActive
                          ? "Скрыть графики"
                          : "Показать графики",
                        size: "small",
                      },
                      on: { click: _vm.toggleCharts },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "calculations__actions-item" },
                  [
                    _c("c-button", {
                      attrs: {
                        responsive: true,
                        icon: { icon: "filter-drop", color: "secondary" },
                        label: "Сбросить фильтры столбцов",
                        size: "small",
                        disabled:
                          this.tableData.activeFilteredColumns.length == 0,
                      },
                      on: { click: _vm.resetFiltersColumns },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "calculations__actions-item" },
                  [
                    _c("c-button", {
                      attrs: {
                        responsive: "",
                        icon: "cog",
                        label: "Настроить столбцы",
                      },
                      on: {
                        click: function ($event) {
                          _vm.tableData.settingsModal = true
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      !_vm.isLoadingTable
        ? _c(
            "div",
            { staticClass: "employees-list__table" },
            [
              _c("c-data-table", {
                ref: "table",
                attrs: {
                  "sorted-column": _vm.tableData.sortedColumn,
                  data: _vm.tableData,
                  canAllDelete: _vm.canAllDelete,
                  canDeleteFiilals: _vm.canDeleteFiilals,
                  "disabled-columns": _vm.tableData.disabledColumns,
                  levels: _vm.tableData.levels,
                  "enabled-fields": _vm.enabledFields,
                  "empty-records-label": "Записи не найдены",
                  "filtered-columns": _vm.tableData.filteredColumns,
                  "active-filtered-columns":
                    _vm.tableData.activeFilteredColumns,
                  "reference-list": _vm.referenceFilterList,
                },
                on: {
                  sortedEvent: _vm.refreshTable,
                  getReferenceValues: _vm.setColumnReferenceFilterList,
                  setLevelsDataTable: _vm.setLevelsDataTable,
                  "reset-column-filters": function ($event) {
                    _vm.tableData.activeFilteredColumns = []
                  },
                  "remove-column-filter": _vm.onColumnFilterRemove,
                  "set-column-filter": _vm.onSetColumnFilter,
                  "set-column-filter-by-index": _vm.onSetColumnFilterByIndex,
                  "disable-column-sorted-flag": _vm.onDisableColumnSortedFlag,
                  "change-sorting-column": _vm.onSortingColumnChange,
                },
              }),
              _vm.isLoadingData
                ? _c("c-loader", {
                    attrs: {
                      label: "Загрузка данных",
                      active: _vm.isLoadingData,
                      height: "150",
                    },
                  })
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c("ItemsCount", {
                    attrs: {
                      "shown-items-count": _vm.recordsCount,
                      "total-items-count": _vm.totalRows,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoadingTable
        ? _c("c-loader", {
            attrs: {
              label: "Производится расчёт",
              active: _vm.isLoadingTable,
              height: "500",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }